import React, { memo } from "react";
import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Iconify from "../../../components/Iconify";

// Move GradientCard outside to avoid re-creating it on each render
const GradientCard = styled(motion.div)({
  backgroundImage: "linear-gradient(to right, #985277,#5C374C)",
  padding: "20px",
  borderRadius: "12px",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "6px 6px 4px 0 black",
  },
});

const Trcoursecard = memo(({ project, replacements, navigations }) => {
  return (
    <GradientCard
      initial={{ y: -200, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "center",
          borderRadius: "20px",
          background: "white",
          px: 2,
          mb: "10px",
          py: "5px",
          gap: "5px",
          height: "auto",
        }}
      >
        <Iconify
          icon={"material-symbols:school-rounded"}
          color="#5C374C"
          width={40}
          height={40}
        />
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 700,
            color: "#5C374C",
            textTransform: "uppercase",
          }}
        >
          {project}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontWeight: 500,
            fontSize: 16,
            mb: "5px",
          }}
        >
          Total Replacements
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "20px",
            background: "#fff",
            color: "#5C374C",
            px: "10px",
            py: "5px",
            fontWeight: 700,
            fontSize: 18,
          }}
        >
          {replacements}
        </Box>
      </Box>
      {navigations}
    </GradientCard>
  );
});

export default Trcoursecard;
